export default "__VITE_ASSET__DzlyO9dq__"